import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Colours from '../../definitions/Colours';


function IconPerson({ outlineWidth, stroke, strokeWidth, fill, ...otherProps }) {
    return (
        <IconPerson.Svg
            viewBox="0 0 62 62"
            outlineWidth={outlineWidth}
            strokeColour={stroke}
            strokeWidth={strokeWidth}
            fillColour={fill}
            {...otherProps}
        >
            <circle
                cx="31"
                cy="31"
                r="29"
            />
            <path
                d="M27.42 35.91l-10.37 5.66v1.88c0 .52.41.94.91.94h25.52c.5
                0 .91-.42.91-.94v-1.88l-10.36-5.66M34.03 35.91c3.76-2.24 3.76-8.09
                3.76-8.09v-5.38c-.51-3.06-3.97-5.38-7.07-5.38s-6.56 2.33-7.07 5.38l-.01
                5.38s0 5.68 3.77 8.09"
            />
        </IconPerson.Svg>
    );
}

IconPerson.propTypes = {
    outlineWidth: PropTypes.string,
    stroke: PropTypes.oneOf(
        Object.values(Colours),
    ),
    strokeWidth: PropTypes.string,
    fill: PropTypes.oneOf(
        Object.values(Colours),
    ),
};

IconPerson.defaultProps = {
    outlineWidth: '2px',
    stroke: Colours.BLACKBERRY,
    strokeWidth: '2px',
    fill: Colours.TRANSPARENT,
};

IconPerson.Svg = styled.svg`
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: ${props => props.strokeWidth};
    stroke: ${props => props.strokeColour};
    fill: ${props => props.fillColour};

    circle {
        stroke-width: ${props => props.outlineWidth};
    }

    transition:
        stroke 300ms ease,
        fill 300ms ease;
`;

export default IconPerson;
